'use client'

import {useSearchParams} from 'next/navigation'
import {createContext, useContext, useState, ReactNode, useEffect} from 'react'
import {pauseAndMute} from '@app/components/game-player/game-functions'

interface PlayButtonContextType {
  gameScreenShown: boolean
  showGameScreen: () => void
  hideGameScreen: () => void
}

const PlayButtonContext = createContext<PlayButtonContextType | undefined>(undefined)

export const PlayButtonProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const [gameScreenShown, setGameScreenShown] = useState<boolean>(false)

  const showGameScreen = () => {
    setGameScreenShown(true)
  }

  const hideGameScreen = () => {
    setGameScreenShown(false)
    pauseAndMute()
  }

  return (
    <PlayButtonContext.Provider value={{gameScreenShown, showGameScreen, hideGameScreen}}>
      {children}
    </PlayButtonContext.Provider>
  )
}

export const usePlayButton = (): PlayButtonContextType => {
  const context = useContext(PlayButtonContext)
  if (!context) {
    throw new Error('usePlayButton must be used within a PlayButtonProvider')
  }
  return context
}
